import React, { useRef } from "react";
import { useLocation } from "react-router-dom";
import jsPDF from "jspdf";
import styles from "../ReportView/ReportView.module.css";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import FooterHomePage from "../../components/footerHomePage/footerHomePage";
import TemplatePDFReportView from "./PDFUser/TemplatePDFReportView";
import TemplatePDFReportViewCompany from "./PDFCompany/TemplatePDFReportViewCompany";

const AllPDF = () => {
  const location = useLocation();
  let data = location.state.data;
  const certificateTemplateRef = useRef(null);

  const typeCustomer = data && data.typeCustomer ? data.typeCustomer : null;

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      format: [1200, 2000],
      orientation: "landscape",
      unit: "px",
    });

    let identify;

    if (typeCustomer === "Persona Humana") {
      identify = data && data.cuil ? data.cuil : null;
    } else {
      identify = data && data.cuit ? data.cuit : null;
    }

    doc.html(certificateTemplateRef.current, {
      async callback(doc) {
        // save the document as a PDF with name of Memes
        doc.save(`Informe 3 De Junio ${identify}`);
      },
      autoPaging: "text",
      x: 5,
      y: 5,
      width: 2000, //target width in the PDF document
      windowWidth: 1900, //window width in CSS pixels
    });
  };
  return (
    <div className={styles.allpdfbox}>
      <HeaderLogoIcon />
      <div className={styles.Lealtadviewpdf}>
        <div className={styles.Lealtadboxtittlepdfgenerate}>
          <div className={styles.Lealtadboxbuttongeneratepdf}>
            <button
              className={styles.Lealtadbuttongeneratepdf}
              type="button"
              onClick={handleGeneratePdf}
            >
              Imprimir PDF
            </button>
          </div>
        </div>
        <div className={styles.notviewdiv} ref={certificateTemplateRef}>
          {typeCustomer === "Persona Humana" ? (
            <TemplatePDFReportView data={data} />
          ) : (
            <TemplatePDFReportViewCompany data={data} />
          )}
        </div>
      </div>
      <FooterHomePage />
    </div>
  );
};

export default AllPDF;
